module.exports = __webpack_public_path__ + "img/trgl-16.8ea12509.svg";